import { useEffect, useState } from "react";
import { API_URL } from "../config";
import MetricCard from "../components/MetricCard";
import FiltersLabel from "../components/filters/FiltersLabel";

function Metrics() {
  const [availableLabels, setAvailableLabels] = useState([]);
  const [selectedLabel, setSelectedLabel] = useState(null);
  const [metrics, setMetrics] = useState([]);
  const [loading, setLoading] = useState(false);

  const colors = {
    Generated: { bg: "", text: "" },
    Pending: { bg: "#d0e7ff", text: "#004085" },
    Preapproved: { bg: "#d4edda", text: "#155724" },
    Prerejected: { bg: "#f8d7da", text: "#721c24" },
    Approved: { bg: "#28a745", text: "#ffffff" },
    Rejected: { bg: "#dc3545", text: "#ffffff" },
  };

  // Load labels
  useEffect(() => {
    fetch(`${API_URL}/api/approve/labels`)
      .then((res) => res.json())
      .then((data) => setAvailableLabels(data.map((l) => ({ value: l.id, label: l.name }))))
      .catch((err) => console.error("Error loading labels:", err));
  }, []);

  useEffect(() => {
    const params = [
      { key: null, label: "Generated" },
      { key: "pending", label: "Pending" },
      { key: "preapproved", label: "Preapproved" },
      { key: "prerejected", label: "Prerejected" },
      { key: "approved", label: "Approved" },
      { key: "rejected", label: "Rejected" },
    ];

    setLoading(true);
    Promise.all(
      params.map(async ({ key, label }) => {
        const url = new URL(`${API_URL}/api/images/metrics`);
        if (key !== null) url.searchParams.append("status", key);
        if (selectedLabel) url.searchParams.append("label", selectedLabel.label);

        const res = await fetch(url);
        const data = await res.json();
        return { label, value: typeof data === "number" ? data : 0 };
      })
    )
      .then((results) => {
        const total = results.find((r) => r.label === "Generated")?.value ?? 0;
        setMetrics(
          results.map((item) => ({
            ...item,
            percentage: total > 0 ? (item.value / total) * 100 : 0,
          }))
        );
      })
      .catch((err) => console.error("Error fetching metrics:", err))
      .finally(() => setLoading(false));
  }, [selectedLabel]);

  return (
    <div>
      <FiltersLabel
        availableLabels={availableLabels}
        selectedLabel={selectedLabel}
        setSelectedLabel={setSelectedLabel}
      />
      <div className="container mt-4">
        <h2 className="mb-4">Metrics</h2>

        {loading && <div className="alert alert-info">Loading metrics...</div>}

        {/* Generated */}
        <div className="row justify-content-center">
          {metrics[0] && (
            <div className="col-md mb-3">
              <MetricCard title={metrics[0].label} value={metrics[0].value ?? 0} percentage={metrics[0].percentage}
                bgColor={colors[metrics[0].label]?.bg} textColor={colors[metrics[0].label]?.text} />
            </div>
          )}
        </div>

        {/* Pending */}
        <div className="row justify-content-center">
          {metrics[1] && (
            <div className="col-md mb-3">
              <MetricCard title={metrics[1].label} value={metrics[1].value ?? 0} percentage={metrics[1].percentage}
                bgColor={colors[metrics[1].label]?.bg} textColor={colors[metrics[1].label]?.text} />
            </div>
          )}
        </div>

        {/* Preapproved / Prerejected */}
        <div className="row">
          {metrics[2] && (
            <div className="col-md-6 mb-3">
              <MetricCard title={metrics[2].label} value={metrics[2].value ?? 0} percentage={metrics[2].percentage}
                bgColor={colors[metrics[2].label]?.bg} textColor={colors[metrics[2].label]?.text} />
            </div>
          )}
          {metrics[3] && (
            <div className="col-md-6 mb-3">
              <MetricCard title={metrics[3].label} value={metrics[3].value ?? 0} percentage={metrics[3].percentage}
                bgColor={colors[metrics[3].label]?.bg} textColor={colors[metrics[3].label]?.text} />
            </div>
          )}
        </div>

        {/* Approved / Rejected */}
        <div className="row">
          {metrics[4] && (
            <div className="col-md-6 mb-3">
              <MetricCard title={metrics[4].label} value={metrics[4].value ?? 0} percentage={metrics[4].percentage}
                bgColor={colors[metrics[4].label]?.bg} textColor={colors[metrics[4].label]?.text} />
            </div>
          )}
          {metrics[5] && (
            <div className="col-md-6 mb-3">
              <MetricCard title={metrics[5].label} value={metrics[5].value ?? 0} percentage={metrics[5].percentage}
                bgColor={colors[metrics[5].label]?.bg} textColor={colors[metrics[5].label]?.text} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Metrics;
